import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isAdminSelector } from 'domain/env';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

type CompaniesTitleProps = {
  onClickAdd: () => void;
  companiesCount: number;
};

const CompaniesTitle: React.FC<CompaniesTitleProps> = ({ onClickAdd, companiesCount }) => {
  const isAdmin = useSelector(isAdminSelector);

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Typography variant="h6">
        <FormattedMessage id="companies.title" defaultMessage="Companies List" /> ({companiesCount})
      </Typography>
      {isAdmin && (
        <Button variant="outlined" onClick={onClickAdd} startIcon={<AddOutlinedIcon />} sx={{ ml: 'auto' }}>
          <FormattedMessage id="companies.addBtn" defaultMessage="Add Company" />
        </Button>
      )}
    </Box>
  );
};

export default CompaniesTitle;
